import Model from '@/models/Model.js';

export default class FileSubmissionActivity extends Model {
    static entity = 'file_submission_activities';

    static modelName = 'FileSubmissionActivity';

    static fields() {
        return {
            content_template_id: this.attr(null),
            content: this.attr(null),

            ...super.fields(),

            content_template: this.belongsTo('file_submission_activity_templates', 'content_template_id'),
            activity: this.morphOne('activities', 'contentable_id', 'contentable_type_entity'),
        };
    }
}
